import Title from '@/components/Title/index.vue';
import Banner from '@/components/Banner2';
import Function from '@/components/Advantages/index.vue';
import BusiCard from '@/components/BusiCard/index.vue';
import Advantages2 from '@/components/Advantages2';
import Appointment2 from '@/components/Appointment2/index.vue';
export default {
  name: 'face-recognition',
  components: {
    Title,
    Banner,
    Function,
    BusiCard,
    Advantages2,
    Appointment2
  },
  data() {
    return {
      bannerUrl: require('@/assets/images/technology/FaceRecognition/FaceRecognition-banner.png'),
      bannerTitle: '摄像头人脸识别',
      bannerText: '基于同花顺的深度学习算法和海量数据集，根据摄像头中人物的面部特征等进行活体检测，可实现精准的人脸检测和人脸识别。',
      functionList: [{
        img: require('@/assets/images/technology/FaceRecognition/facergt-offlinestr.png'),
        title: '离线3D结构光活体检测',
        desc: '基于3D结构光成像原理，通过人脸表面反射光线构建深度图像，判断目标对象是否为活体，可强效防御图片、视频、屏幕、模具等攻击。'
      }, {
        img: require('@/assets/images/technology/FaceRecognition/facergt-offlinenir.png'),
        title: '离线近红外活体检测',
        desc: '利用近红外成像原理，实现夜间或无自然光条件下的活体判断。其成像特点（如屏幕无法成像，不同材质反射率不同等）可以实现高鲁棒性的活体判断。'
      }, {
        img: require('@/assets/images/technology/FaceRecognition/facergt-offlinergb.png'),
        title: '离线RGB活体检测',
        desc: '在线图片活体的离线版本，相对于在线接口方式，本地处理速度更快，无需担心是否有网络，也无需考虑接口调用次数等消耗。'
      }, {
        img: require('@/assets/images/technology/FaceRecognition/facergt-interactive.png'),
        title: '动作配合式活体检测',
        desc: '给出指定动作要求，用户需配合完成，通过实时检测用户眼睛，嘴巴，头部姿态的状态，来判断是否是活体。支持多种预设动作，可自定义哪些生效以及检测顺序。'
      }],
      businessList: [{
        img: require('@/assets/images/technology/FaceRecognition/facergt-app1.png'),
        title: '人证核验机',
        desc: '通过活体检测判断用户是否为真人，将活体验证后的人脸图片与证件人脸图片相比对，确保当前用户为“本人”且为“真人”，完成人证核验比对。'
      }, {
        img: require('@/assets/images/technology/FaceRecognition/facergt-app2.png'),
        title: '人脸通行验证',
        desc: '在通过人脸搜索验证通行人员身份之前，使用活体检测完成真人验证，防止作弊通行，全程无感知核验，保障安全的同时，确保人员通行效率。 '
      }, {
        img: require('@/assets/images/technology/FaceRecognition/facergt-app3.png'),
        title: '自助柜机业务',
        desc: '基于活体检测判断是否为真人操作，用于判断业务是否需要继续进行，防止使用他人信息作弊办理业务，全程无感知活体检测，保障用户体验不受损。'
      }, {
        img: require('@/assets/images/technology/FaceRecognition/facergt-app4.png'),
        title: '金融行业',
        desc: '通过人脸识别进行身份认证，极大缩短业务办理时间，提升业务安全性。'
      }],
      leftItems: [{
        title: '开放参数配置',
        desc: '多平台支持，各种主流系统下的应用开发，满足人脸能力多端覆盖'
      }],
      rightItems: [{
        title: '稳定低功耗',
        desc: '低功耗、低CPU占用率，均衡资源使用，避免因设备性能引发的卡顿等问题'
      }, {
        title: '识别率高',
        desc: '对于一般生活场景中的人脸，达到99%的准确率和98%的召回率'
      }]
    };
  }
};